import axios from '../../config/axios'
import { auth as types } from '../../constants/types'
import { request as HTTP_REQUEST } from '../../constants/types';
import { requestAxios } from './helpers';

const _request = async (path, dispatch, login = {}) => {
    dispatch(setLoading());
    try {
        console.log(path);
        const response = await axios.post(`/auth/${path}`, login);
        console.log(response)
        dispatch(setError(null));
        const { data: { user, token: { auth, refresh } } } = response;
        localStorage.setItem('AUTHORIZATION_TOKEN_BLOG', auth);
        localStorage.setItem('REFRESH_TOKEN_BLOG', refresh);
        localStorage.setItem('user', JSON.stringify(user));
        dispatch({ type: types.LOGGED_IN });
        } catch (error) {
        let { message } = error?.response?.data || error;
        console.log(error)
        message instanceof Object && (message = error.message)
        dispatch(setError(message))
    }
    dispatch(setLoading());
}
export const setLogin = login => dispatch => {
    dispatch({
        type: types.LOGIN,
        payload: login
    });
}
export const setLoading = () => dispatch => {
    dispatch({
        type: types.LOADING
    });
}
export const setError = error => dispatch => {
    dispatch({
        type: types.ERROR,
        payload: error
    });
}
export const login = () => async (dispatch, getState) => {
    const { auth: { login } } = getState()
    await _request('login', dispatch, login);
}
export const refresh = () => async dispatch => {
    await _request('refresh', dispatch);
}

// Action Types for forgot password
export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAILURE = 'FORGOT_PASSWORD_FAILURE';

// Action Creator for sending forgot password email
export const sendForgotPasswordEmail = (email) => async (dispatch) => {
    dispatch({ type: FORGOT_PASSWORD_REQUEST });

    try {
        console.log("sending password rest link")
        await requestAxios(HTTP_REQUEST.GET, `/auth/forgot-password/${email}`);
        dispatch({ type: FORGOT_PASSWORD_SUCCESS, payload: "Reset email sent successfully!" });
    } catch (error) {
        dispatch({
            type: FORGOT_PASSWORD_FAILURE,
            payload: error.response?.data?.message || 'Something went wrong',
        });
    }
};

// eslint-disable-next-line import/no-anonymous-default-export
export default { setLogin, login, refresh }


